import { render, staticRenderFns } from "./titleMenu2.vue?vue&type=template&id=0f03f052&scoped=true&"
import script from "./titleMenu2.vue?vue&type=script&lang=js&"
export * from "./titleMenu2.vue?vue&type=script&lang=js&"
import style0 from "./titleMenu2.vue?vue&type=style&index=0&id=0f03f052&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f03f052",
  null
  
)

export default component.exports